import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationModalComponent } from './modals/notification-modal/notification-modal.component';

@NgModule({
	imports: [CommonModule, SharedModule],
	declarations: [NotificationModalComponent, NotificationComponent],
	exports: [NotificationModalComponent, NotificationComponent],
})
export class NotificationModule {}
